<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-rotate-device`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 4a2 2 0 012 2v14h14a2 2 0 012 2v20a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h20zm-2 4H8v32h16V8zm4 16h12v16H28V24zm-12 8a3 3 0 110 6 3 3 0 010-6zm27.44-18.44A20.51 20.51 0 0034.37 5a2 2 0 00-2.67 1 2 2 0 00.94 2.65 16.7 16.7 0 017.3 6.89 2 2 0 001.75 1v.02a2 2 0 001.75-3z"/></svg>
</template>
<script>

export default {
  name: 'IconRotateDevice',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
